
import { defineComponent, ref, computed } from 'vue';
import Modal from '@/components/general/molecules/Modal.vue';
import TableComponent from '@/components/general/molecules/TableComponent.vue';
import { FormattedDataResident } from '@/services/communities/types';
export default defineComponent({
    emit: ["update:visible", "update"],
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        item: {
            type: FormattedDataResident,
            default: () => {
                return {};
            }
        },
    },
    setup(props, { emit }) {
        const showModal = ref<boolean>(props.visible || false)
        const searchTableData = ref(['firsName', 'name'])
        const showButtons = computed(() => false)
        const columns = ref([{ name: 'description', label: 'Descripción' }])
        const columnsUnits = ref([{ name: 'address', label: 'Dirección' }, { name: 'floor', label: 'Pisos' }, { name: 'establishmentType', label: 'Tipo de establecimiento' }])
        const establishments = [
            { value: 1, label: 'Oficina' },
            { value: 2, label: 'Residencia' },
            { value: 3, label: 'Local Comercial' },
        ];
        const formattedData = computed(() => {
            return props.item.units.map((item) => {
                return {
                    floor: item.unit.floor,
                    address: item.unit.address,
                    establishmentType: establishments[item.unit.establishmentType -1].label,
                }
            })
        })
        const closeModal = () => {
            // showModalAlert.value = true
            showModal.value = false
            console.log(showModal.value)
            emit('closeModal')
        };

        return {
            closeModal,
            showModal,
            columns,
            showButtons,
            searchTableData,
            columnsUnits,
            formattedData
        };
    },
    components: { Modal, TableComponent, },
});

